import { Modal } from "@t8891/pc-v1";
import React from "react";
import AskPriceDiscounts from "./AskPriceDiscounts";
// import { fetchActiveInfo } from "@Services/api";
import { useQuery } from "react-query";
import styles from "./AskPriceModal.module.less";
import PartyModalHeader from "@Components/campaigns/2022/partyModalHeader";

const Header = ({ data }) => {
    return (
        <div className={styles["ask-price-discounts-banner-item"]}>
            <div className={styles["discounts-date"]}>{data.countdown}</div>
            <div className={styles["discounts-price-item"]}>
                <div>優惠禮包</div>
                <div className={styles["price"]}>{data.packageValue}</div>
            </div>
            <div className={styles["discount-region"]}>
                {data.regionName}業代提供
            </div>
        </div>
    );
};
const HeaderActivity = ({ data }) => {
    return (
        <div className={styles["activity-price"]}>
            <div className={styles["ask-price-discounts-banner-item"]}>
                <div className={styles["discounts-date"]}>優惠禮包</div>
                <div className={styles["discounts-price-item"]}>
                    <div className={styles["activity-price-text-1"]}>
                        最高省
                        <span>{data.totalPrice.replaceAll("萬", "")}</span>萬
                    </div>
                    <div className={styles["activity-price-text"]}>
                        (優惠禮包{data.packageValue}+抽購車金
                        {data.activityPrice})
                    </div>
                </div>
                <div className={styles["discount-region"]}>
                    {data.regionName}業代提供
                </div>
            </div>
        </div>
    );
};

const AskPriceModal: React.FC<any> = ({
    visible,
    setVisible,
    data,
    kindId,
    brandId,
    source,
}) => {

    return (
        <section>
            <Modal
                className={styles["AskPriceDiscountsModal"]}
                visible={visible}
                closeLocation="top"
                title={
                    <Header data={data} />
                }
                onClose={() => setVisible(false)}
            >
                <div>
                    <AskPriceDiscounts
                        source={source}
                        regionId={data.regionId}
                        brandId={brandId}
                        setVisible={setVisible}
                        k={kindId}
                        id={data.id}
                    />
                </div>
            </Modal>
        </section>
    );
};
export default AskPriceModal;
